var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.886,
    height: 24,
    viewBox: "0 0 23.886 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screenshot-at-Sep-16-22-10-36",
    transform: "translate(-47.017 335.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_899",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 899",
    d: "M63.2-335.835A12.056,12.056,0,0,0,56-332.523l-.654.628v-1.212c0-.985-.026-1.273-.157-1.508a1.186,1.186,0,0,0-2.057-.157c-.174.235-.183.366-.209,3.47l-.026,3.217h3.121c2.8,0,3.156-.017,3.426-.157a1.169,1.169,0,0,0,.523-1.648c-.3-.488-.541-.584-1.6-.628l-.95-.026.253-.262a10.277,10.277,0,0,1,3.531-2.162,7.571,7.571,0,0,1,3.208-.471,7.172,7.172,0,0,1,2.293.235,9.637,9.637,0,0,1,7.14,8.273c.1.968.253,1.282.706,1.491a1.173,1.173,0,0,0,1.717-1.177,12.067,12.067,0,0,0-1.177-4.507,12.04,12.04,0,0,0-8.1-6.46,19.022,19.022,0,0,0-2.842-.34C64.085-335.914,63.649-335.87,63.2-335.835Z",
    transform: "translate(-5.37)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_900",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 900",
    d: "M47.635-204.738c-.628.314-.75.915-.488,2.432a12.14,12.14,0,0,0,5.187,8.012,12.042,12.042,0,0,0,11.194,1.1A11.819,11.819,0,0,0,67.3-195.68l.636-.6v1.212c0,.985.026,1.273.157,1.508a1.186,1.186,0,0,0,2.057.157c.174-.235.183-.366.209-3.47l.026-3.217H67.268c-2.8,0-3.156.017-3.426.157a1.169,1.169,0,0,0-.523,1.648c.3.488.541.584,1.6.628l.95.026-.253.262a10.734,10.734,0,0,1-2.136,1.552,9.7,9.7,0,0,1-8.483.27,9.61,9.61,0,0,1-5.553-7.7c-.1-.968-.253-1.282-.706-1.491A1.167,1.167,0,0,0,47.635-204.738Z",
    transform: "translate(0 -119.625)",
    fill: "#2066a3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.639c1e44bc03669457fd2dee5e89b759.svg";
export { ForwardRef as ReactComponent };